import { FC, useEffect } from "react";

import { SecondaryOverlay } from "components/constants";
import { t } from "i18n/i18n";
import { Button } from "mds/components/Button";
import { ButtonBadge } from "mds/components/ButtonBadge";
import { ChatWithLinesFilledIcon, ChatWithLinesIcon } from "mds/icons";
import { storeApi, useAppSelector } from "store/index";
import {
  selectCurrentCourseId,
  selectUnreadChatMessageCountForCurrentCourse,
} from "store/selectors";
import { useOverlayControls } from "utils/routing/hooks/use-overlay-controls";

export const ChatPanelToggleButton: FC<{ isLarge?: boolean }> = ({ isLarge = false }) => {
  const { isSelected, togglePanel } = useOverlayControls(SecondaryOverlay.ClassChat);
  const unreadChatMessageCount = useAppSelector(selectUnreadChatMessageCountForCurrentCourse);
  const courseId = useAppSelector(selectCurrentCourseId);

  useEffect(() => {
    if (courseId) {
      storeApi.chat_messages.list({ course_id: courseId });
    }
  }, [courseId]);

  return (
    <Button
      className="relative size-[44px] min-h-[44px] min-w-[44px]"
      eventName="Class Chat - Toggle"
      eventProps={{ isOpened: !isSelected }}
      isSelected={isSelected}
      kind="squareLegacy"
      title={t("content_sidebar.title.ClassChat")}
      isSquare
      onClick={togglePanel}
    >
      {unreadChatMessageCount ? (
        <ChatWithLinesFilledIcon size={isLarge ? "l" : "m"} />
      ) : (
        <ChatWithLinesIcon size={isLarge ? "l" : "m"} />
      )}
      {Boolean(unreadChatMessageCount) && <ButtonBadge>{unreadChatMessageCount}</ButtonBadge>}
    </Button>
  );
};
